import { withInstall } from '@tav-ui/utils/with-install'
import CascadeProSelect from './src/cascade-pro-select.vue'
const TaCascadeProSelect = withInstall(CascadeProSelect)
export { TaCascadeProSelect }
export default TaCascadeProSelect
export * from './src/types/props'
